import { ENV, OVERSIGHT_ENV_NAME } from 'params'
import Api from 'services/Api'

const { protocol } = window.location
const HOST_NAME = ENV === 'dev' ? 'localhost' : `api-${OVERSIGHT_ENV_NAME}.flytrex.com`
const BASE_URL = `${protocol}//${HOST_NAME}:7701/api/v1/`

const api = new Api(BASE_URL)

export default api